import { useGetMerchantFeatureFlags } from "./queries/useMerchantQueries";

// Single source of truth for whether per-channel balances (mpesa/bank/airtel)
// are shown on the merchant dashboard. Strict `=== true` so loading/error
// states fail closed (hidden) rather than flashing the section before the
// flag resolves.
export function useViewChannelBalances() {
  const { data: featureFlags } = useGetMerchantFeatureFlags();
  return featureFlags?.viewChannelBalances === true;
}

export default useViewChannelBalances;
